// isGoogleSignInAvailable is the one rule for whether a Google button may render,
// shared by the signup form ("Sign up with Google") and the portal login ("Sign
// in with Google"): a client ID is configured (an empty one is the fail-closed
// state) and the browser is not an in-app webview, where Google refuses sign-in.
// Neither button is behind a feature flag or an experiment; the server-side kill
// switch is GOOGLE_SIGNIN_ENABLED, whose 503 makes each page hide its button
// (docs/google-sign-in.md).

import { isEmbeddedWebView } from "./embeddedBrowser";
import { getGoogleSignInClientID } from "./sharedUtils";

export function isGoogleSignInAvailable() {
  return Boolean(getGoogleSignInClientID()) && !isEmbeddedWebView();
}
